export default "__VITE_ASSET__JZXdzCG5__"